module.exports = __webpack_public_path__ + "static/img/ic-car.efab396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ic-car.png
// module id = tFEW
// module chunks = 55